<script setup lang="ts" generic="T extends {type: string, id: number, name?: string | null}">
import {computed} from "vue";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue
} from "@/core/components/ui/select";
import {AcceptableValue} from "reka-ui";

const props = defineProps<{
    tags: T[];
    modelValue: T | null;
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', tag: T | null): void;
}>();

const programTags = computed(() => props.tags.filter(t => t.type === 'program'));
const laboratoryTags = computed(() => props.tags.filter(t => t.type === 'laboratory'));

const selectValue = computed(() => props.modelValue ? String(props.modelValue.id) : 'all');

/**
 * Handle tag selection.
 */
const onSelectTag = (value: AcceptableValue) => {
    if (!value || value === 'all') {
        emit('update:modelValue', null);
    } else {
        const tag = props.tags.find(t => String(t.id) === String(value)) ?? null;
        emit('update:modelValue', tag);
    }
};
</script>

<template>
  <Select :model-value="selectValue" @update:model-value="onSelectTag">
    <SelectTrigger class="w-64 text-right">
      <SelectValue placeholder="Filtrer par tag" />
    </SelectTrigger>
    <SelectContent align="center">
      <SelectItem value="all">
        Tous les modèles
      </SelectItem>
      <SelectGroup v-if="programTags.length > 0">
        <SelectLabel>Programmes</SelectLabel>
        <SelectItem v-for="tag in programTags" :key="tag.id" :value="String(tag.id)">
          {{ tag.name }}
        </SelectItem>
      </SelectGroup>
      <SelectGroup v-if="laboratoryTags.length > 0">
        <SelectLabel>Laboratoires</SelectLabel>
        <SelectItem v-for="tag in laboratoryTags" :key="tag.id" :value="String(tag.id)">
          {{ tag.name }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>
